// extracted by mini-css-extract-plugin
export default {"heading":"SinglePageContainer_heading__Tsunp","stickyHeader":"SinglePageContainer_stickyHeader__AECr6","pageTitle":"SinglePageContainer_pageTitle__3mIfN"};